import ManageParticipants from './ManageParticipants';

export default ManageParticipants;
